import Intro from "../../../../src/components/v8-parser/intro";
import * as React from 'react';
export default {
  Intro,
  React
};